
export default function HelpNavService(gettextCatalog) {

    'ngInject';
    
    var module = {
        "id": "help",
        "name": gettextCatalog.getString("Help"),
        "sref": "help",
        "priority": 60
    };

    this.getModule = function () {
        return module;
    };

}
